import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Header from '../../components/common/Header';
import {
  getAllLabsOrder,
  getDigitsationStatus,
  getOrderHistory,
} from '../../services/lab-test';
import LoadingComponent from '../../components/common/LoadingComponent';
import { PrimaryButton } from '../../components/common/Buttons';
import { logEvent } from '../../utils/logEvent';
import { setCurrentActiveTab } from '../../actions';

import arrowLeft from '../../images/common/arrow-left.svg';
import PlacedCheck from '../../images/lab-test/placed-check.svg';
import noTests from '../../images/lab-test/noLab.svg';
import arrowRight from '../../images/common/arrow-right.svg';
import ellipseIcon from '../../images/common/ellipse.svg';
import tickIcon from '../../images/common/tick.svg';
import cautionIcon from '../../images/common/caution.svg';
import greenTick from '../../images/common/green-tick.svg';
import profileIcon from '../../images/common/profile.svg';
import stethoscope from '../../images/pharmacy/stethoscope.png';
import arrowRightFill from '../../images/lab-test/arrowright-fill.svg';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: white;
  overflow: hidden;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  z-index: 999;
  background: #ffffff;
  padding: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const OrdersContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
  padding-top: 0;
  align-self: stretch;
  align-items: stretch;
`;

class AllLabOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orders: [],
      loading: true,
    };
    // const { state } = props.location;

    // if (state) {
    //   this.goBack = state.goBack;
    //   this.goHome = state.goHome;
    // }
    this.openOrder = this.openOrder.bind(this);
  }

  componentDidMount = () => {
    // GA Tracking
    window.gtag('event', 'screen_view', {
      screen_name: 'Labs Home Screen',
    });
    logEvent('Labs Orders Screen');
    this.getOrders();
    this.props.dispatch(setCurrentActiveTab('labs-orders'));
  };

  // getOrders() {
  //   const { authToken } = this.props;
  //   getAllLabsOrder(authToken)
  //     .then((res) => {
  //       console.log(res);
  //       const { orders } = res;
  //       this.setState({
  //         orders: orders,
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       this.setState({
  //         loading: false,
  //       });
  //     });
  // }

  getOrders() {
    const { authToken } = this.props;
    getOrderHistory(authToken)
      .then((res) => {
        const { cards } = res;
        this.setState({
          orders: cards,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  openOrder(order) {
    const {
      cardType: type,
      orderId,
      digitisationId,
      cartId,
      reimbursementId,
      status,
      testsType,
    } = order;
    const { history, authToken } = this.props;
    // console.log(orderId)
    history.push('/lab-test/order-status', {
      orderId: orderId,
      digitisationId: digitisationId,
      cartId: cartId,
    });
  }

  render() {
    const { orders, loading } = this.state;
    const { history } = this.props;

    const renderOrder = (ele) => {
      return (
        <PrescriptionStatusCard
          orderRequest={ele}
          onTap={this.openOrder}
        ></PrescriptionStatusCard>
      );
    };

    return (
      <OuterContainer>
        <div className="header p-16px pt-0 mt-28px border-b border-txtsecondary-shades4 flex flex-row items-center justify-between">
          <div className="flex flex-row items-center cursor-pointer">
            <img
              src={arrowLeft}
              alt="back"
              onClick={() => {
                this.props.history.goBack();
              }}
            />
            <p className="text-title-m font-semibold text-txtlight">
              Order History
            </p>
          </div>
        </div>
        {loading ? (
          <LoadingComponent />
        ) : (
          <BodyContainer>
            {orders.length > 0 ? (
              <OrdersContainer>{orders.map(renderOrder)}</OrdersContainer>
            ) : (
              <div className="flex flex-col justify-center items-center w-full h-full">
                <img src={noTests} alt="no test" />
                <p
                  className="text-body-l text-brochure text-center"
                  style={{ marginTop: '34px', marginBottom: '34px' }}
                >
                  You don't have an ongoing lab tests, click below to request a
                  lab test.
                </p>
                <PrimaryButton
                  className="w-full text-center"
                  onTap={() => history.push('/lab-test')}
                >
                  <div className="text-body-l font-bold py-4px">
                    Book Lab Test
                  </div>
                </PrimaryButton>
              </div>
            )}
          </BodyContainer>
        )}
      </OuterContainer>
    );
  }
}

const PrescriptionStatusCard = ({ orderRequest, onTap }) => {
  const { cardType: type, digitisationId } = orderRequest;

  if (type === 'pending-digitisation') {
    return (
      <div
        className="hover p-16px pb-12px mt-16px border border-txtsecondary-shades7 border-solid rounded-12"
        onClick={() => onTap(orderRequest)}
      >
        <div className="flex flex-row justify-between	items-center pb-4px">
          <span className="text-title-s font-semibold">
            Prescription Uploaded
          </span>
          <img className="float-right" src={arrowRight} alt="right" />
        </div>
        <div className="flex flex-row items-center pb-4px">
          <img
            src={ellipseIcon}
            alt="ellipse"
            height={11}
            width={12}
            className="icon-spin"
          />
          <span className="text-body-s text-secondary-shades6 font-regular pl-8px ">
            Transcribing Prescription
          </span>
        </div>
        <div className="text-body-s font-regular text-txtsecondary-shades8 pb-24px">
          The transcription will take 12hr-24hrs
        </div>
        {/* <div className="text-chip text-txtsecondary">
          {orderRequest.prescribedTime}
        </div> */}
      </div>
    );
  } else if (type === 'reimbursement') {
    return (
      <div
        className="hover p-16px pb-12px mt-16px border border-txtsecondary-shades7 border-solid rounded-12"
        onClick={onTap}
      >
        <div className="flex flex-row justify-between	items-center pb-4px">
          <span className="text-title-s font-semibold">Reimbursement</span>
          <img className="float-right" src={arrowRight} alt="right" />
        </div>
        <div>
          <p className="lab-test-name mt-13">{orderRequest.patientName}</p>
          <p className="txt-grey-600-12 mt-4 mb-4">
            {orderRequest.prescriptionGivenOn}
          </p>

          <p className="txt-black-600-12 lab-home-btn hover" onClick={onTap}>
            {orderRequest.btnLabel}
          </p>
        </div>
      </div>
    );
  } else if (type === 'booked-order') {
    return (
      <div className="p-16px pt-0 pb-12px mt-16px border border-txtsecondary-shades7 border-solid	rounded-12">
        <span
          className="py-4px px-12px text-secondary-shades2 text-body-s font-semibold"
          style={{
            background: 'rgba(207, 200, 255, 0.2)',
            borderRadius: '0px 0px 8px 8px',
          }}
        >
          {orderRequest.testsType}
        </span>
        <div className="flex flex-row justify-between pt-12px items-center pb-4px">
          <div className="flex flex-row items-center">
            {orderRequest.status === 'pending' ||
            orderRequest.status === 'completed' ? (
              <img src={tickIcon} alt="tick" height={11} width={12} />
            ) : (
              <img src={cautionIcon} alt="tick" height={11} width={12} />
            )}
            <div
              className="text-body-s font-semibold pl-8px"
              style={
                orderRequest.status === 'pending' ||
                orderRequest.status === 'completed'
                  ? { color: '#3F8CFF' }
                  : { color: '#FF754C' }
              }
            >
              {orderRequest.status === 'payment-pending'
                ? orderRequest.pendingCopayText || orderRequest.status
                : orderRequest.status}
            </div>
          </div>
        </div>
        <div className="text-title-s font-semibold">
          {orderRequest.testNames}
        </div>
        {orderRequest.doctorName && (
          <div className="flex flex-row items-center pb-2px">
            <img src={stethoscope} alt="stethoscope" height={12} width={12} />
            <div className="text-body-s text-txtsecondary font-medium pl-4px ">
              {orderRequest.doctorName}
            </div>
          </div>
        )}
        <div className="flex flex-row items-center pb-24px">
          <img src={profileIcon} alt="profile" height={12} width={12} />
          <div className="text-body-s text-txtsecondary font-medium pl-4px ">
            {orderRequest.patientName}
          </div>
        </div>
        <div className="flex flex-row justify-between items-center">
          <div className="text-chip text-txtsecondary">
            {orderRequest.bookedOn}
          </div>
          <div
            className="flex flex-row hover"
            onClick={() => {
              onTap(orderRequest);
            }}
          >
            <p className="text-body-l text-primary font-semibold mr-8px">
              {orderRequest.status === 'payment-pending'
                ? 'Pay & Confirm'
                : 'View Details'}
            </p>
            <img src={arrowRightFill} alt="" />
          </div>
        </div>
      </div>
    );
  } else if (type === 'available-cart') {
    return (
      <div className="p-16px pt-0 pb-12px mt-16px border border-txtsecondary-shades7 border-solid	rounded-12">
        <div className="flex flex-row items-center mt-16px">
          <img src={tickIcon} alt="tick" height={11} width={12} />
          <p className="text-body-s font-semibold text-secondary-shades6 ml-4px">
            Transcribed
          </p>
        </div>
        <div className="text-body-l font-semibold text-txtlight pt-4px pb-4px">
          Tests Ready for order
        </div>
        <div className="text-title-s font-semibold">
          {orderRequest.testNames}
        </div>
        {orderRequest.doctorName && (
          <div className="flex flex-row items-center pb-2px">
            <img src={stethoscope} alt="stethoscope" height={12} width={12} />
            <div className="text-body-s text-txtsecondary font-medium pl-4px ">
              {orderRequest.doctorName}
            </div>
          </div>
        )}
        <div className="flex flex-row items-center pb-24px">
          <img src={profileIcon} alt="profile" height={12} width={12} />
          <div className="text-body-s text-txtsecondary font-medium pl-4px ">
            {orderRequest.patientName}
          </div>
        </div>
        <div>
          <div className="text-chip text-txtsecondary">
            {orderRequest.prescriptionGivenOn}
          </div>
          <div
            className="bg-primary hover rounded-12 max-w-100 mt-8px py-10px text-center"
            onClick={() => {
              onTap(orderRequest);
            }}
          >
            <p className="text-body-l text-txtlight font-semibold">
              View & Confirm
            </p>
          </div>
        </div>
      </div>
    );
  } else {
    return <div />;
  }
};

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  insured: state.app.config.insured,
});

export default connect(mapStateToProps)(AllLabOrders);
